import { TFunction } from 'i18next';
import * as React from 'react';
import { Trans } from 'react-i18next';

export const getText = (t: TFunction) => ({
  playerIconsPopUp: (
    <Trans i18nKey='playerIconsPopUpText' components={{ strong: <strong /> }}>
      We automatically set the color of icons and text based on your color
      choice to either white or black. Make sure there is{' '}
      <strong>enough contrast</strong> when switching from the default setting.
    </Trans>
  ),
  downloadModal: {
    downloadModalTitle: t('Download Video'),
  },
  deleteModal: {
    deleteModalTitle: t('Move video to recently deleted bin?'),
    deleteModalBody: (
      <>
        <br />
        {t(
          'This video will be permanently deleted after 30 days, removed from the company folder if shared, and recipients will no longer be able to view this video.'
        )}
        <br />
      </>
    ),
    deleteModalMultipleSelectedBody: (
      <>
        <br />
        {t(
          'These videos will be permanently deleted after 30 days, removed from the company folder if shared, and recipients will no longer be able to view this video. If the video was sent with a repair order, the RO that was created with it will be locked and you will not be able to edit it or Send&Share it.'
        )}
        <br /> <br />
      </>
    ),
    deleteMultipleModalBody: (
      <>
        <br />
        {t(
          'These videos will be permanently deleted after 30 days, removed from the company folder if shared, and recipients will no longer be able to view this video.'
        )}
        <br />
      </>
    ),
    deleteModalWithROBody: t(
      'Deleting the video, the RO that was created with it gets locked and you will not be able to edit it or Send&Share it.'
    ),
    deleteModalCompanyBody: (
      <>
        {t(
          'This will delete the video from the Company Folder, but leave it in the primary folder.'
        )}
        <br />
      </>
    ),
  },
  moveCopyModal: {
    MoveCopyModalTitle: t('Move/Copy Video'),
    checkboxText: t('Keep a copy of this video in the current folder'),
  },
  trimModal: {
    trimModalTitle: t('You are about to trim a video'),
    trimModalBody: t(
      'You are about to trim a video. If doing so the new video would placed in your Primary folder.'
    ),
    trimButtonText: t('Trim'),
    cancelButtonText: t('Cancel'),
  },
  mergeModal: {
    mergeModalTitle: t('You are about to merge a video'),
    mergeModalBody: t(
      'You are about to merge a video. If doing so the new video would placed in your Primary folder.'
    ),
    mergeButtonText: t('Merge'),
    cancelButtonText: t('Cancel'),
  },
});
